import React from "react";

export const GroupListItemLoading = () => {
    return (
        <div className="flex full-width b-x-width-none b-t-width-none b-b-width-sm border-light-grey p-t-spacer-lg p-b-spacer-sm p-r-spacer-lg rel-pos">
            <div className="w-100 ht-80 animate-shimmer ec-rounded" />
            <div className="flex full-width flex-column m-l-spacer-lg align-end">
                <div className="text-alt-dark-grey full-width animate-shimmer m-b-spacer-sm element-loading-shimmer" />
                <div className="text-alt-dark-grey full-width animate-shimmer m-b-spacer-sm element-loading-shimmer" />
                <div className="text-alt-dark-grey full-width animate-shimmer m-b-spacer-md element-loading-shimmer" />
                <div className="text-alt-dark-grey full-width animate-shimmer m-b-spacer-md element-loading-shimmer" />
            </div>
        </div>
    );
};
